import { Injectable, Injector } from '@angular/core';
import { Planner } from '@authority-labs/api-interfaces';
import { Path } from '@authority-labs/enums';
import { CrudService } from '../../shared/services/crud/crud.service';

@Injectable({
  providedIn: 'root'
})
export class PlannersService extends CrudService<Planner> {
  constructor(injector: Injector) {
    super(injector, Path.Planners, Planner);
  }
}
